import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import TrashCanIcon from 'dibs-icons/exports/TrashCan';

import styles from './DesignProjectTileEditOverlay.scss';

type Props = {
    isVisible: boolean;
    isAdminMode: boolean;
    editPath: string;
    onDelete: () => void;
};

export const DesignProjectTileEditOverlay: FC<Props> = ({
    isVisible,
    onDelete,
    editPath,
    isAdminMode,
}) => {
    if (!isVisible) {
        return null;
    }

    const linkOptions = isAdminMode
        ? {
              rel: 'nofollow,noopener',
              target: '_blank',
          }
        : {};

    return (
        <div className={styles.wrapper}>
            <div className={styles.deleteButton} onClick={onDelete}>
                <TrashCanIcon className={styles.trashIcon} />
            </div>
            <a className={styles.editButton} href={editPath} {...linkOptions}>
                <FormattedMessage
                    id="abt.designProfile.DesignProjectTileEditOverlay.editProject"
                    defaultMessage="Edit Project"
                />
            </a>
        </div>
    );
};
